import { render, staticRenderFns } from "./TiposTurno.vue?vue&type=template&id=fb0fdcf2&scoped=true"
import script from "./TiposTurno.vue?vue&type=script&lang=js"
export * from "./TiposTurno.vue?vue&type=script&lang=js"
import style0 from "./TiposTurno.vue?vue&type=style&index=0&id=fb0fdcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0fdcf2",
  null
  
)

export default component.exports